import { AccessClient } from "./axiosInstance.js";

/**
 * 모든 퀘스트를 가져옵니다.
 * @returns 
 */
export const loadAllQuests = async () => {
    try {
        const response = await AccessClient.get("/api/quests");
        const {
            status,
            data: {
                data: quests,
            }
        } = response;

        return { status, quests };
    } catch (error) {
        if (error.response) {
            const {
                status,
                data: { message },
            } = error.response;
            return { status, message };
        }
        throw error;
    }
};


// 퀘스트에 대한 정보 가져오기
export const loadQuest = async ({ id }) => {
    try {
        const response = await AccessClient.get(`/api/quests/${id}`);
        //console.log("response : ", response);
        const {
            status,
            data: { data, message },
        } = response;
        return { status, data, message };
    } catch (error) {
        const {
            status,
            data: { message },
        } = error.response;

        //console.log(status);
        //console.log(message);

        return { status, message };
    }
};

// 퀘스트에 대한 정보 저장하기
export const saveQuest = async ({ id, info, building }) => {
    //console.log("saveProfessor => ", id, weekId, weekState, weekAuth);

    try {
        const response = await AccessClient.put(`/api/quests/${id}`, {
            info: info,
            building: building,
        });
        const {
            status,
            data: { data, message },
        } = response;

        return { status, course: data, message };
    } catch (error) {
        const {
            status,
            data: { message },
        } = error.response;
        return { status, message };
    }
};


export const saveQuiz = async (id, content) => {
    console.log("saveQuiz id : ", id, ", content : ", content )

    try{
        const response = await AccessClient.post("/api/quests/savequiz", {
            id: id,
            quiz : content
        });

        const{
            status,
            data: {data, message},            
        } = response;

        return {status, quiz: data, message};
    }catch(error){
        const{
            status,
            data: {message},
        } = error.response;
        return { status, message}
    }
};

export const save7Quiz = async (id, content) => {
    console.log("save7Quiz id : ", id, ", content : ", content )

    try{
        const response = await AccessClient.post("/api/quests/save7quiz", {
            id : id,
            quiz : content
        });

        const{
            status,
            data: {data, message},            
        } = response;

        return{ status, quiz: data, message};
    } catch(error){
        const{
            status,
            data: {message},
        } = error.response;
        return {status, message}
    }
}